import React from 'react';

import { Col, Row, Tag } from 'antd';
import { getDate } from '../../shared/utils/date';
import { convertTitleToUrl } from '../../shared/utils/url';
import { storageImage } from '../../shared/utils/storage-image';
import { News } from '../../shared/models/news';
import { NEWS_DESCRIPTION_LENGTH } from '../../shared/variables/constants';
import Link from 'next/link';

export default function NewsRow({ news }: { news: News.News }) {
  const newsUrl = news.external_url || convertTitleToUrl('haber', news.haber_baslik, news.id);
  const isExternal = !!news.external_url;
  // Card column is ~1/3 of the container (≤400 px); originals reach 0.5 MB.
  const image = storageImage(news.haber_foto_url, 400) || '/images/default.jpg';

  return (
    <Row gutter={[0, 0]} className="news-card">
      {/* Mobile: thumbnail left, text right — five stacked full-width cards took ~2000px. */}
      <Col xs={8} lg={8}>
        <Link href={newsUrl}>
          <a
            className="news-card-image-link"
            target={isExternal ? '_blank' : undefined}
            rel={isExternal ? 'noreferrer' : undefined}
            // Same destination as the title link: keep one tab stop per story.
            tabIndex={-1}
            aria-hidden="true"
          >
            <div
              className="news-image"
              style={{ backgroundImage: `url("${image}")` }}
            />
          </a>
        </Link>
      </Col>
      <Col xs={16} lg={16} className="news-card-content">
        <Link href={newsUrl}>
          <a target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noreferrer' : undefined}>
            <h3 className="news-card-title">{news.haber_baslik}</h3>
          </a>
        </Link>
        <p className="news-card-meta">
          {news.haber_etiket && <Tag>{news.haber_etiket}</Tag>}
          <time>{getDate(news.haber_tarih)}</time>
        </p>
        {!!news.haber_detay && (
          <p className="news-card-summary">
            {news.haber_detay.length > NEWS_DESCRIPTION_LENGTH
              ? `${news.haber_detay.substring(0, NEWS_DESCRIPTION_LENGTH)}...`
              : news.haber_detay}
          </p>
        )}
      </Col>
    </Row>
  );
}
